$(document).ready(function () {
    "use strict";

    const showMore = $(".js_showFullContent");
    const showLess = $(".js_showExcerpt");

    if (showMore.length > 0) {
        showMore.click((element) => {
            const button = $(element.currentTarget);

            button.closest(".excerpt").hide();
            button.closest(".topContent").find(".fullContent").show();
        });
    }

    if (showLess.length > 0) {
        showLess.click((element) => {
            const button = $(element.currentTarget);

            button.closest(".fullContent").hide();
            button.closest(".topContent").find(".excerpt").show();
        });
    }
});
